import { render, staticRenderFns } from "./phoneSheet.vue?vue&type=template&id=3c19026e&scoped=true"
import script from "./phoneSheet.vue?vue&type=script&lang=js"
export * from "./phoneSheet.vue?vue&type=script&lang=js"
import style0 from "./phoneSheet.vue?vue&type=style&index=0&id=3c19026e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19026e",
  null
  
)

export default component.exports